import { Emptied } from '@utils/types';
import { Schedule, ScheduleType, TaskType } from '@root/globalTypes';
import { ReschedulerJob, ReschedulerTask } from '../types';
import { ScheduleDialogType } from './types';
import { InternalScheduleDialogInitialParams } from '@components/schedules/dialogs/internal/types';

export const parseSchedule = (
  job: Emptied<ReschedulerJob>,
  task: Emptied<ReschedulerTask>,
): Schedule => {
  const { id: taskId, name, appearance, schedule } = task;
  const { id, address, projectId, division, project } = job;

  return {
    ...schedule,
    id: schedule?.id || 'new',
    task: {
      ...task,
      id: taskId,
      name: name || '',
      appearance,
      job: { ...job, id, projectId, name: job.name, address, division, project },
    },
  };
};

export const parseInitialParams = (
  initialParams?: InternalScheduleDialogInitialParams,
  taskSpecialty?: string,
) => {
  if (!initialParams) return {};

  const specialties = initialParams.specialties?.filter(Boolean) || undefined;
  const users = initialParams.users?.filter(Boolean) || undefined;

  return {
    users,
    specialties:
      taskSpecialty && specialties?.includes(taskSpecialty) ? [taskSpecialty] : specialties,
  };
};

export const getScheduleDialogType = (scheduleType?: ScheduleType, taskType?: TaskType) => {
  if (scheduleType === 'dependent' && taskType === 'material_measurement') return 'finalYards';
  if (scheduleType === 'external' && taskType === 'material_order') return 'order';
  return scheduleType as ScheduleDialogType;
};
